import { render, staticRenderFns } from "./VotingCount.vue?vue&type=template&id=75155395&scoped=true"
import script from "./VotingCount.vue?vue&type=script&lang=js"
export * from "./VotingCount.vue?vue&type=script&lang=js"
import style0 from "./VotingCount.vue?vue&type=style&index=0&id=75155395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75155395",
  null
  
)

export default component.exports